
import {Component, Vue} from 'vue-property-decorator';

const routeGuardAdmin = async (to, from, next) => {
  // @ts-ignore
  // if (!hasAccess(window.getApp.$store, to.meta)) {
  //   next('/main/dashboard');
  // } else {
  //   next();
  // }
};

@Component
export default class Admin extends Vue {
  // public beforeRouteEnter(to, from, next) {
  //   routeGuardAdmin(to, from, next);
  // }
  //
  // public beforeRouteUpdate(to, from, next) {
  //   routeGuardAdmin(to, from, next);
  // }
}
